import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VApp,
    [
      _c("navbar"),
      _vm._v(" "),
      _c(
        VMain,
        [
          _c(
            VContainer,
            {
              staticClass: "align-content-start pa-0 fill-height",
              attrs: { fluid: _vm.isHomepage },
            },
            [
              _vm.authenticated
                ? _c(VBreadcrumbs, {
                    staticClass: "flex-shrink-1 d-print-none",
                    attrs: { items: _vm.breadcrumbs },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                VContainer,
                {
                  class: {
                    "pa-0": !_vm.authenticated,
                    "pt-0": _vm.authenticated,
                  },
                  attrs: { fluid: "" },
                },
                [
                  _c(
                    "router-view",
                    [
                      _c(
                        VRow,
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            VCol,
                            {
                              staticClass: "text-center",
                              attrs: { cols: "4" },
                            },
                            [
                              _c(VProgressCircular, {
                                attrs: {
                                  color: "primary",
                                  indeterminate: "",
                                  size: "150",
                                  width: "5",
                                },
                              }),
                            ],
                            1,
                          ),
                        ],
                        1,
                      ),
                    ],
                    1,
                  ),
                ],
                1,
              ),
            ],
            1,
          ),
          _vm._v(" "),
          _c("AlertDialog"),
          _vm._v(" "),
          _c("b-toaster", {
            staticStyle: {
              position: "absolute",
              right: "10px",
              top: "10px",
              "z-index": "9999",
            },
            attrs: { name: "b-toaster-top-right" },
          }),
        ],
        1,
      ),
      _vm._v(" "),
      !_vm.inProduction
        ? _c(
            VAlert,
            { staticClass: "mc-test-alert", attrs: { type: "error" } },
            [_vm._v("TEST")],
          )
        : _vm._e(),
    ],
    1,
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }